import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      50: "#F8F1F6",
      100: "#E9D9E5",
      200: "#D1B3CA",
      300: "#B98CAF",
      400: "#A16694",
      500: "#5B2E4F", // Primary brand color
      600: "#4D2743",
      700: "#3F2037",
      800: "#31192B",
      900: "#23121F",
    },
    background: {
      main: "#F8F9FC",
    },
    text: {
      primary: "#33343D",
      secondary: "#666666",
      muted: "#999999",
    },
  },
  fonts: {
    body: "satoshi, sans-serif",
    heading: "satoshiBold, sans-serif",
    satoshi: "satoshi, sans-serif",
    satoshiBold: "satoshiBold, sans-serif",
    satoshiBolder: "satoshiBolder, sans-serif",
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
        borderRadius: "6px",
      },
      variants: {
        solid: {
          bg: "brand.500",
          color: "white",
          _hover: {
            bg: "brand.600",
          },
        },
        outline: {
          borderColor: "brand.500",
          color: "brand.500",
          _hover: {
            bg: "brand.50",
          },
        },
      },
    },
    Text: {
      baseStyle: {
        color: "text.primary",
      },
    },
  },
});

export default theme;
